export default "/images/Banner_sgp4.png?694bbed75eb041a16e456b49cf3172a4";